import React from "react";
import i18n from "../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import Et3PageTitle from "../../../core/et3-page-title/index";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import getCorePopUpStore from "../../../stores/core/core-popup-store";
import PromoCodeForm from "./promo-code-form";
import ET3PageDiv from "../../../core/et3-page-div";
import Et3Button from "../../../core/et3-button";
import getPromoCodeGenerationStore from "../../../stores/communications-store/promocode-generate";
import Et3Margin from "../../../core/et3-ui/ET3Margin";

const PromoCodeGenerator = withLiteObserverAndTheme(() => {
  React.useEffect(() => {
    getCoreHistoryStore().setPageName(
      "COMMUNICATIONS_PROMO_CODE_GENERATOR",
      "COMMUNICATIONS_PROMO_CODE_GENERATOR"
    );
  }, []);
  const disabled = getPromoCodeGenerationStore().generateButtonDisabled.get();
  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("COMMUNICATIONS_PROMO_CODE_GENERATOR")}
        subTitle={i18n.get("PROMO_CODE")}
        withRefresh={false}
        withHelper={true}
        onPress={() => {
          getCorePopUpStore().showHelperMessage(
            "PROMO_CODE_GENERATION_HELPER_TEXT"
          );
        }}
      />
      <PromoCodeForm />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Button
        isEnabled={!disabled}
        onClick={async () => {
          getPromoCodeGenerationStore().generatePromoCode();
        }}
        size="LARGE"
        type="APPROVE"
        text="GENERATE"
      />
    </ET3PageDiv>
  );
});
export default PromoCodeGenerator;
